import { create } from "zustand";
import { Trainee } from "../types/user";

type TraineeStore = {
    trainee: Trainee;
    getTrainee: () => Trainee;
    setTrainee: (trainee: Partial<Trainee>) => void;
};

const defaultTrainee: Trainee = {
    name: "",
    email: "",
    phone: "",
    governorate: "",
    city: "",
    password: "",
    profileImage: null,
    gender: "male",
};

const useTraineeStore = create<TraineeStore>((set, get) => ({
    trainee: defaultTrainee,

    getTrainee: () => get().trainee,

    setTrainee: (updatedTrainee) =>
        set((state) => ({
            trainee: { ...state.trainee, ...updatedTrainee }, 
        })),
}));

export default useTraineeStore